import React, { Fragment } from 'react';
import './accounts.scss';
import AccountsMainNav from 'components/web/Accounts/AccountMainNav';
import { connect } from 'react-redux';
import AccountMenu from 'components/web/Accounts/AccountMenu';
import {
  getOrders,
  postReorder,
} from 'hb-redux-store/feature/accounts/accounts.action';
import { postLogout } from 'hb-redux-store/feature/login/login.action';
import { isLoggedInUser } from 'hb-redux-store/util/cookieService';
import Orders from './Orders';
import Address from './Address';
import SavedPayments from './SavedPayments';
import Wallet from './Wallet';
import Referral from './Referral';
import FAQs from './FAQs';
import TnC from './TnC';
import PrivacyPolicy from './PrivacyPolicy';
import history from 'hb-redux-store/history';
import { showLoginModal } from 'hb-redux-store/feature/modal/modal.action';
import { Link } from 'react-router-dom';
import Icon from 'components/mweb/Icon/Icon';
import FAQList from 'components/web-feature/account/FAQList';
import OrderDetails from './OrderDetails';
import HBMoney from '../../../feature/account/Wallet/HBMoney';
import LandingPage from '../../../feature/account/HBPoint/LandingPage';
import { withRouter } from 'react-router';

class AccountHome extends React.Component {
  state = {
    selectedMenu: 'orders',
    randomKey: Math.random(),
    trackOrderStatus: false,
    topicName: '',
    orderNo: '',
  };

  componentWillMount() {
    this.onRouteChange();
  }

  componentDidMount() {
    isLoggedInUser() && this.props.getOrders();
  }

  componentDidUpdate() {
    window.onpopstate = e => {
      const componentName = history?.location?.pathname.split('/')[2];
      e.preventDefault();
      if (this.state.selectedMenu === 'faq-list' && componentName === 'faqs')
        this.setState({ selectedMenu: 'faqs', topicName: '' });
      else this.onRouteChange();
    };
  }

  componentWillReceiveProps(nextProps) {
    const componentName = history?.location?.pathname.split('/')[2];
    if (componentName === 'vxl-point') this.getSelectedMenu(componentName);

    if (nextProps?.location?.pathname !== history?.location?.pathname)
      this.onRouteChange();
  }

  onRouteChange() {
    const topicList = [
      'general',
      'payments & refunds',
      'order & delivery faqs',
      'halal & quality faqs',
    ];
    const componentName = history?.location?.pathname.split('/')[2],
      params = history?.location?.pathname.split('/')[3];
    if (params && topicList.includes(params)) {
      this.setTopicName(params);
      this.getSelectedMenu('faq-list');
    } else if (componentName === 'order') {
      this.setOrderNo(params);
      this.getSelectedMenu('order-details');
    } else {
      this.setState({
        selectedMenu: componentName === 'details' ? 'orders' : componentName,
      });
    }
  }

  getSelectedMenu = selectedMenu => {
    this.setState({ selectedMenu, randomKey: Math.random() });
  };

  setTopicName = topicName => {
    this.setState({ topicName });
  };

  trackOrder = isTrackOrder => {
    this.setState({ trackOrderStatus: isTrackOrder });
  };
  setOrderNo = orderNo => {
    this.setState({ orderNo, selectedMenu: 'order-details' });
  };

  renderComponent = selectedMenu => {
    const loggedInUser = isLoggedInUser();
    switch (selectedMenu) {
      case 'orders':
        return (
          <Fragment>
            {loggedInUser && this.props.onGoingOrders?.orderSet?.length > 0 && (
              <Orders
                title="Ongoing Order"
                orders={this.props.onGoingOrders.orderSet}
                selectedMenu={this.getSelectedMenu}
                trackOrder={this.trackOrder}
                orderNo={this.setOrderNo}
              />
            )}
            {loggedInUser &&
              this.props.pastOrders?.orderSet?.length > 0 &&
              !this.state.trackOrderStatus && (
                <Orders
                  title="Past Orders"
                  orders={this.props.pastOrders.orderSet}
                  pastOrders
                  onReorder={orderNo => this.props.postReorder({ orderNo })}
                  trackOrder={this.trackOrder}
                  orderNo={this.setOrderNo}
                />
              )}
            {loggedInUser &&
              this.props.pastOrders?.orderSet?.length === 0 &&
              this.props.onGoingOrders?.orderSet?.length === 0 && (
                <div className="desktop-cart--empty-cart-container">
                  <div className="desktop-cart--empty-cart-left">
                    <div className="desktop-cart--empty-cart-icon">
                      <Icon class="icon-cart-empty-cart" size={241} />
                    </div>
                    <div className="desktop-cart--empty-cart-oops">Whoops!</div>
                    <div className="desktop-cart--empty-cart-msg">
                      No orders has been placed yet.
                    </div>
                    <div className="desktop-cart--empty-cart-cta">
                      <Link to="/" className="button button-primary">
                        View Products
                      </Link>
                    </div>
                  </div>
                </div>
              )}
          </Fragment>
        );
      case 'addresses':
      case 'new-address':
        return (
          <div className="desktop-my-accounts--container">
            {' '}
            <Address />
          </div>
        );
      case 'payments':
        return <SavedPayments />;
      // case 'halalbox-wallet':
      //   return <Wallet />;
      case 'vxl-point':
        const HbPointComponent = withRouter(LandingPage);
        return <HbPointComponent />;
      case 'vxl-money':
        const HbMoneyComponent = withRouter(HBMoney);
        return <HbMoneyComponent />;
      case 'referrals':
        return <Referral />;
      case 'faqs':
        return (
          <FAQs
            selectedMenu={this.getSelectedMenu}
            topicName={this.setTopicName}
          />
        );
      case 'tnc':
        return <TnC location={this.props.location} />;
      case 'privacy-policy':
        return <PrivacyPolicy />;
      case 'faq-list':
        return (
          <FAQList
            faqTopic={this.state.topicName}
            selectedMenu={this.getSelectedMenu}
            topicName={this.setTopicName}
          />
        );
      case 'order-details':
        return <OrderDetails orderNo={this.state.orderNo} />;
    }
  };

  render() {
    return (
      <div className="desktop-my-accounts">
        <div className="desktop-my-accounts--left">
          <div className="desktop-my-accounts--left-child">
            <AccountsMainNav />
            <AccountMenu
              onLogout={this.props.postLogout}
              isReferralActive={this.props.launchInfo?.referralActive}
              selectedMenu={this.getSelectedMenu}
              activeMenu={this.state.selectedMenu}
            />
          </div>
        </div>
        <div
          className="desktop-my-accounts--content"
          key={this.state.randomKey} // reload on click of link
        >
          {this.renderComponent(this.state.selectedMenu)}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ initialReducer, accountsReducer, cartReducer }) => ({
  launchInfo: initialReducer.launchInfo,
  onGoingOrders: accountsReducer.onGoingOrders,
  pastOrders: accountsReducer.pastOrders,
  cartQty: cartReducer.cartQtyCount,
});

const mapDispatchToProps = {
  getOrders,
  postLogout,
  showLoginModal,
  postReorder,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountHome);
